import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import {
  Settings,
  BarChart2,
  Cpu,
  Activity,
  Layers,
  TrendingUp,
} from "lucide-react";
import heroImage from "../../assets/Construction.png";
import "./Manufacturing.css";

export default function Manufacturing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      {/* HERO SECTION */}
      <section
        className="manufacturing-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="manufacturing-hero-overlay"></div>
        <div className="manufacturing-hero-content">
          <h1>Smart Manufacturing</h1>
          <p>Empowering factories with intelligent automation and precision.</p>
        </div>
      </section>

      {/* INTRO */}
      <section className="manufacturing-intro">
        <h2>Redefining Industrial Productivity</h2>
        <p>
          At Larch, we enable digital transformation in manufacturing through
          seamless integration, data intelligence, and connected systems — paving
          the path for the factories of tomorrow.
        </p>
      </section>

      {/* CORE FOCUS AREAS */}
      <section className="manufacturing-focus">
        <h2>Core Focus Areas</h2>
        <div className="focus-cards">
          <div className="focus-card">
            <Settings className="focus-icon" />
            <h3>Operational Efficiency</h3>
            <p>
              Streamline production with optimized workflows and real-time
              decision-making.
            </p>
          </div>

          <div className="focus-card">
            <BarChart2 className="focus-icon" />
            <h3>Data-Driven Insights</h3>
            <p>
              Harness analytics to identify bottlenecks and enhance productivity
              across your operations.
            </p>
          </div>

          <div className="focus-card">
            <Cpu className="focus-icon" />
            <h3>Automation & AI</h3>
            <p>
              Integrate smart machines, robotics, and AI algorithms for agile
              and adaptive production.
            </p>
          </div>

          <div className="focus-card">
            <Activity className="focus-icon" />
            <h3>Quality Traceability</h3>
            <p>
              Ensure end-to-end product quality with traceable data across the
              entire manufacturing chain.
            </p>
          </div>
        </div>
      </section>

      {/* SMART FACTORY EVOLUTION */}
{/* SMART FACTORY EVOLUTION */}
<section className="smart-factory">
  <h2>The Smart Factory Evolution</h2>
  <div className="Manufacture-timeline">
    <div className="Manufacture-timeline-item">
      <div className="Manufacture-timeline-content">
        <h3><i className="fas fa-network-wired icon-inline"></i> Connected Infrastructure</h3>
        <p>
          Real-time data sharing across systems and assets enables seamless collaboration 
          and smarter decision-making.
        </p>
      </div>
    </div>

    <div className="Manufacture-timeline-item">
      <div className="Manufacture-timeline-content">
        <h3><i className="fas fa-robot icon-inline"></i> Automation-Driven Production</h3>
        <p>
          Robotics and AI-based control systems streamline complex operations while 
          ensuring accuracy and consistency.
        </p>
      </div>
    </div>

    <div className="Manufacture-timeline-item">
      <div className="Manufacture-timeline-content">
        <h3><i className="fas fa-chart-line icon-inline"></i> Continuous Improvement</h3>
        <p>
          Predictive analytics drive constant optimization, reducing downtime and 
          enhancing productivity.
        </p>
      </div>
    </div>
  </div>
</section>


      {/* IMPACT METRICS */}
      <section className="manufacturing-impact">
        <h2>Manufacturing Impact</h2>
        <div className="impact-stats">
          <div className="stat">
            <h3>40%</h3>
            <p>Increased Equipment Uptime</p>
          </div>
          <div className="stat">
            <h3>25%</h3>
            <p>Faster Production Cycles</p>
          </div>
          <div className="stat">
            <h3>99.8%</h3>
            <p>Process Accuracy</p>
          </div>
          <div className="stat">
            <h3>100%</h3>
            <p>Traceability Across Operations</p>
          </div>
        </div>
      </section>

      <ERPChatbot />
      <Footer />
    </>
  );
}
